<template>
    <div>
        <vc-left-menu></vc-left-menu>

        <div :class="{ 'layout-content': true, 'is-active': !getMenuToggle }">
            <div class="page-header-container">
                <div class="page-header">
                    <h3 class="page-title">{{ $t('words.media_profile_groups') }}<span class="text-tooltip v-tooltip-open" v-tooltip="{ content: $t('paragraphs.profile.group_tip1') + '<br>' + $t('paragraphs.profile.group_tip2') }"><i class="icon icon-info-circle-line"></i></span></h3>
                </div>
            </div>
            <div class="page-body">
                <table class="table table__module">
                    <thead>
                    <tr>
                        <th>{{ $t('words.profile_group_name') }} | {{ $t('words.profile_group_key') }} </th>
                        <th>{{ $t('words.profile_selected_name') }}</th>
                        <th class="text-right">{{ $t('words.profile_group_screen_type') }}</th>
                    </tr>
                    </thead>
                    <tbody v-if="load && (total > 0)">
                    <tr v-for="profileGroup in profileGroups.data" :key="profileGroup.encoded_id">
                        <td>
                            <router-link class="text-link" :to="{ name: 'cms-preferences-profile-groups-view', params: { profile_group_id: profileGroup.id } }">{{ profileGroup.name }}</router-link>
                            <span class="badge badge__live" v-if="profileGroup.has_onair_channel">{{ $t('words.live_onair') }}</span>
                            <div>{{ profileGroup.key }}</div>
                        </td>
                        <td>
                            <span :class="`badge badge__profile__${profile.name.replace(/p$/,'')}`" v-for="profile in profileGroup.profiles" :key="profile.encoded_id">{{ profile.name }}</span>
                        </td>
                        <td class="text-right">
                            {{ profileGroup.screen_type==='portrait' ? $t('paragraphs.profile.screen_type.portrait') : $t('paragraphs.profile.screen_type.landscape') }}
                        </td>
                    </tr>
                    </tbody>
                    <tbody v-else-if="load">
                    <tr>
                        <td colspan="3" class="td__message">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg>{{ $t('paragraphs.profile.list_empty') }}</td>
                    </tr>
                    </tbody>
                    <tbody v-else>
                    <tr>
                        <td colspan="3" class="td__message"><div class="loader"></div>{{ $t('paragraphs.list_loading') }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</template>
<script>
import GlobalConfigMixin from '../mixin/GlobalConfigMixin';

export default {
    mixins: [
        GlobalConfigMixin,
    ],
    data() {
        return {
            profileGroups: {},
            total: 0,
            load: false,
        };
    },
    mounted() {
        if (this.loadedServiceAccount) {
            this.initialize();
        }
    },
    methods: {
        initialize() {
            this.loadProfileGroups(this.profileGroupApiUri);
        },
        loadProfileGroups(profileGroupApiUri) {
            this.load = false;
            axios.get(profileGroupApiUri).then((response) => {
                this.profileGroups = response.data;
                this.total = this.profileGroups.data.length;
                this.load = true;
            });
        },
    },
    computed: {
        profileGroupApiUri() {
            return `/cms/${this.selectedServiceAccount.key}/profile_groups`;
        },
    },
    watch: {
        loadedServiceAccount(newValue) {
            this.initialize();
        },
    },
};
</script>
